"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bot_chat_1 = require("../../messages/bot-chat");

var guest_chat_1 = require("../../messages/guest-chat");

var notification_1 = require("../../messages/notification");

var peer_1 = require("../../messages/peer");

var roster_1 = require("../../messages/roster");

var base_1 = __importDefault(require("../base"));

var methods_factory_1 = require("../methods-factory");

var GuestClient =
/*#__PURE__*/
function (_base_1$default) {
  _inherits(GuestClient, _base_1$default);

  function GuestClient(options) {
    var _this;

    _classCallCheck(this, GuestClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GuestClient).call(this, options));
    _this.acceptNoStaffOnline = methods_factory_1.AcceptMessageFactory(guest_chat_1.NoStaffOnline, 1);
    _this.acceptProxyGuestChatDecline = methods_factory_1.AcceptMessageFactory(guest_chat_1.ProxyGuestChatDecline, 1);
    _this.acceptProxyGuestChatRequestTimeout = methods_factory_1.AcceptMessageFactory(guest_chat_1.ProxyGuestChatRequestTimeout, 1);
    _this.acceptGuestRoster = methods_factory_1.AcceptMessageFactory(roster_1.GuestRoster, 1);
    _this.acceptHandshake = methods_factory_1.AcceptMessageFactory(peer_1.PeerHello, 1);
    _this.acceptMessage = methods_factory_1.AcceptMessageFactory(peer_1.PeerMessage, 1);
    _this.acceptNotification = methods_factory_1.AcceptMessageFactory(notification_1.GuestNotification, 1);
    _this.acceptBotMessage = methods_factory_1.AcceptMessageFactory(bot_chat_1.BotMessage, 1);
    _this.unacceptNoStaffOnline = methods_factory_1.UnacceptMessageFactory(guest_chat_1.NoStaffOnline);
    _this.unacceptProxyGuestChatDecline = methods_factory_1.UnacceptMessageFactory(guest_chat_1.ProxyGuestChatDecline);
    _this.unacceptProxyGuestChatRequestTimeout = methods_factory_1.UnacceptMessageFactory(guest_chat_1.ProxyGuestChatRequestTimeout);
    _this.unacceptGuestRoster = methods_factory_1.UnacceptMessageFactory(roster_1.GuestRoster);
    _this.unacceptHandshake = methods_factory_1.UnacceptMessageFactory(peer_1.PeerHello);
    _this.unacceptMessage = methods_factory_1.UnacceptMessageFactory(peer_1.PeerMessage);
    _this.unacceptBotMessage = methods_factory_1.UnacceptMessageFactory(bot_chat_1.BotMessage);
    _this.sendGuestChatComplete = methods_factory_1.SendMessageFactory();
    _this.sendHandshake = methods_factory_1.SendMessageFactory();
    _this.sendMessage = methods_factory_1.SendMessageFactory();
    _this.sendBotMessage = methods_factory_1.SendMessageFactory();
    _this.sendProxyGuestChatRequest = methods_factory_1.SendMessageFactory();
    return _this;
  }

  return GuestClient;
}(base_1.default);

exports.GuestClient = GuestClient;
exports.default = GuestClient;